import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { CgpAppBarService } from '../shared/cgp-app-bar/cgp-app-bar.service';
import { cgpAuthentication } from '../../modules/cgp-authentication';
import { CgpIdleService } from '../shared/cgp-idle/cgp-idle.service';

@Component({
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

    constructor(
        private readonly appService: AppService,
        private readonly cgpAppBarService: CgpAppBarService,
        private readonly cgpIdleService: CgpIdleService
    ) { }

    ngOnInit() {
        this.appService.logout();
        this.cgpAppBarService.logout();
        this.cgpIdleService.clearTimers();
        cgpAuthentication.invalidateToken(null);
    }

}
